import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { useAccessRolStore } from '@/shared/access';
import { useAccess } from '@/shared/access';

export const validateAccessRol = async (
  to: RouteLocationNormalized,
): Promise<boolean | RouteLocationRaw | string | void> => {
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    return true;
  }

  const accessRolStore = useAccessRolStore();
  await accessRolStore.getAccessRol();

  if (!to.meta?.accessRol?.section) return true;
  
  const { hasAccess } = useAccess({
    section: to.meta?.accessRol?.section,
    actions: to.meta?.accessRol?.actions,
  });

  if (!hasAccess.value) {
    return { name: 'forbidden' };
  }
  
  return true;
}